import React, {useContext, useEffect, useState} from "react";
import * as Constants from "./util/Constants";
import * as Helpers from "./util/Helpers";
import "./assets/styles.css";
import { useGlobalneVarijable } from "hooks/useGlobalneVarijable";
import Grupa from "./types/Grupa";
import { getGrupe } from "db";


    const Podgrupe = () => {
        const [grupe, setGrupe] = useState<{ GrupaSifra: number; Naziv: string }[]>([]);

        useEffect(() => {
            const fetchData = async () => {
                const data = await getGrupe();
                setGrupe(data);
            };
            fetchData();
        }, []);

    return (
        <div className={"podgrupe"}>
            <div className={"podgrupe-container"}>
                {grupe.map((grupa) => (
                    <div className={"podgrupa"} key={"Grupa"+grupa.GrupaSifra}>Grupa {grupa.GrupaSifra} {grupa.Naziv}</div>
                ))}
            </div>
        </div>
    );

};


export default Podgrupe;
